var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasIpi)?_c('div',[_vm._v(" "+_vm._s(_vm._f("number")(_vm.percentual,'0.00'))+"% ("+_vm._s(_vm._f("currency")(_vm.ofertaCarrinho.impostoTotalAVista))+") "),(_vm.small)?_c('span',[_vm._v("de IPI")]):_vm._e(),(!_vm.small)?_c('div',{staticClass:"body-2"},[_vm._v(" de IPI ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }